import React, {Component} from 'react';
import './DesignAndBuild.css';
import IndustryIndividualMoreCard from '../../../Components/IndustryIndividualMoreCard/IndustryIndividualMoreCard.js'
import design_buildImg1 from '../../../../../images/individual/realestate/DNB.jpg';
import design_buildImg2 from '../../../../../images/individual/realestate/ITEAM.jpg';

export default class DesignAndBuild extends Component {
	render() {
		return (
			<div className="design_build_container">
				<div className="objective_title">DESIGN AND BUILD</div>
				<hr className="objective_break"/>
				<div className="objective_subtitle">We identify unique project requirements and explore alternative design solutions that are generated through collaborative interaction with the homeowners. To this date, PPI has contracted more than S$18 million in construction values.</div>

				<div className="design_build_content">
					<IndustryIndividualMoreCard
						image={design_buildImg1}
						title= 'BENEFITS OF DESIGN & BUILD'
						description1='PPI has a full team of architects, structural engineers and interior designers.  This identifies all the costs for our clients to plan their entire budget. With full coordination between designers and contractors, PPI ensures that all costs are revealed upfront, with no hidden liabilities.'
						description2='We provide a single point of contact for both design and construction process, improving on quality, cost control and schedules, and closely collaborate between construction, real estate and design disciplines to result in countless benefits to the project and our valued clients.'
					/>
					<IndustryIndividualMoreCard
						image={design_buildImg2}
						title='AN INTEGRATED TEAM'
						description1='We provide full architectural services, cost consultancy, project management systems, building works and specialty works.'
						description2='Our architects take on efficient space planning for the entire house or built forms.  Our engineers certify structural safety and our designers work on beautifying the interiors. Pacific Prince handles these aspects for our clients as our key advantages.  By having our architects and interior designers working closely together, the space requirements and functions of our buildings are taken into careful consideration.'
					/>
				</div>
			</div>
		);
	}
}
